
import invoke from '../utils/invoke';
import config from '../config.json';
export const getNftPath = (query,value) => {
    return invoke({
        url : `${config.NFT_BACKEND_API}/v1/nft/media/path?${query}=${value}`,
        method  :   'GET'
    })
}
